import {Popover, Tooltip} from 'bootstrap';

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    // Define window.jQuery como null para evitar a detecção do jQuery
    (window as any).jQuery = null;

    const initializeTooltips = () => {
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        new Tooltip(el);
      });
    };

    const initializePopovers = () => {
      document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
        new Popover(el);
      });
    };

    nuxtApp.hook('app:mounted', () => {
      initializeTooltips();
      initializePopovers();
    });

    // Adiciona suporte para re-inicialização dinâmica
    nuxtApp.hook('page:finish', () => {
      initializeTooltips();
      initializePopovers();
    });
  }
});
